@if (showLoader) {
  <div class="loader-wrapper">
    <app-loader></app-loader>
  </div>
}


<div class="register-form-wrapper text-start">
  <ng-content></ng-content>

  <form #userForm="ngForm">
    <!-- new header -->
    <h2 class="form-header text-start fw-bold font-sans-serif mb-4 mt-2">
      Skapa ditt konto
    </h2>

    <!-- Social Security Number -->

    <h2 class="text-header text-start">
      Personnummer
    </h2>

    <div class="form-group has-error">
      <div class="mb-3">
        <div class="input-wrapper custom-input-group align-items-center d-flex position-relative">
          <img src="../../assets/icons/Personnummer.svg" alt="" class="input-icon-left" />

          <input class="input-field w-100 fs-6 font-sans-serif" [class.input-field-error]="showInputErrorMessages && 
            socialSecurityNumberControl.errors?.pattern &&
            socialSecurityNumberControl.dirty &&
            socialSecurityNumberControl.touched &&
            (registerData.socialSecurityNumber?.length ?? 0) > 0"
            type="text" id="socialSecurityNumber" pattern="^\d{8}-\d{4}$" placeholder="Personnummer"
            [(ngModel)]="registerData.socialSecurityNumber" name="socialSecurityNumber" minlength="12" maxlength="13" [disabled]="dataFetchedFromSsn"
            #socialSecurityNumberControl="ngModel" (input)="onInputChangeSSN($event)" />
          </div>

          @if (showInputErrorMessages) {
            @if (
              socialSecurityNumberControl.errors?.pattern &&
              socialSecurityNumberControl.dirty &&
              socialSecurityNumberControl.touched &&
              (registerData.socialSecurityNumber?.length ?? 0) > 0
              ) {
              <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field">
                <i class="error-msg-icon"></i>
                <img alt="" src="../../assets/icons/error.svg" />
                {{ errorMessages.ssn.wrongFormat }}
              </p>
            }

          }
        </div>
      </div>

      <!-- Togge section "btn" -->
      <p class="collapse-toggle font-sans-serif fs-6 d-flex align-items-start gap-2" (click)="toggleSection(!isExpanded)">
        Har du inte personnummer?
        <i class="fa-solid fa-chevron-down fs-5" [class.rotated]="isExpanded"></i>
      </p>

      <!-- collapsable form section -->
      <section class="form-group collapsible-content" [class.expanded]="isExpanded">
        @if(fetchedIncompleteUserData) {
          <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-bad-fetch mb-4">
            <i class="error-msg-icon "></i>
            <img alt="" src="../../assets/icons/error.svg" />
            {{ errorMessages.fetchedIncompleteUserData }}
          </p>
        }

        <!-- names -->
        <h2 class="text-header text-start">
          Namn
        </h2>
        <div class="input-field-wrapper form-group has-error d-flex justify-content-between gap-3">
          <!-- firstname -->
          <div>
            <input class="input-field field-without-icon w-100 fs-6 font-sans-serif"
              [class.input-field-error]="showInputErrorMessages && (nameControl.errors?.required)" [disabled]="dataFetchedFromSsn" required type="text"
              id="name" placeholder="Namn 1" [(ngModel)]="registerData.firstName" name="name" #nameControl="ngModel" />

              @if(showInputErrorMessages) {
                @if (nameControl.errors?.required) {
                  <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field"
                    >
                    <i class="error-msg-icon "></i>
                    <img alt="" src="../../assets/icons/error.svg" />
                    {{ errorMessages.names.first.required }}
                  </p>
                }
              }
            </div>

            <!-- lastname -->

            <div>

              <input class="input-field field-without-icon w-100 fs-6 font-sans-serif"
                [class.input-field-error]="showInputErrorMessages && (surnameControl.errors?.required)" [disabled]="dataFetchedFromSsn" required type="text"
                id="surname" placeholder="Efternamn 1" [(ngModel)]="registerData.lastName" name="surname"
                #surnameControl="ngModel" />

                @if (showInputErrorMessages) {
                  @if (surnameControl.errors?.required) {
                    <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field"
                      >
                      <i class="error-msg-icon "></i>
                      <img alt="" src="../../assets/icons/error.svg" />
                      {{ errorMessages.names.last.required }}
                    </p>
                  }
                }
              </div>
            </div>

            <!-- address - city -->
            <h2 class="text-header text-start">
              Adress
            </h2>


            <!-- adress - street -->
            <div class="input-field-wrapper form-group has-error">
              <input class="input-field field-without-icon w-100 fs-6 font-sans-serif"
                [class.input-field-error]="showInputErrorMessages && (streetControl.errors?.required)" [disabled]="dataFetchedFromSsn" required type="text"
                id="street" placeholder="Gata*" [(ngModel)]="registerData.address.street" name="street"
                #streetControl="ngModel" />

                @if (showInputErrorMessages) {
                  @if (streetControl.errors?.required) {
                    <p class="text-danger help-block font-sans-serif f-for-input-fields-6 error-msg-for-input-field"
                      >
                      <i class="error-msg-icon "></i>
                      <img alt="" src="../../assets/icons/error.svg" />
                      {{ errorMessages.street.required }}
                    </p>
                  }
                }
              </div>

              <!-- adress - zip code -->
              <div class="input-field-wrapper form-group has-error">
        <input class="input-field w-100 field-without-icon fs-6 font-sans-serif" [class.input-field-error]="showInputErrorMessages && (
            zipCodeControl.errors?.required || registerData.address.zipCode?.length !== 5
          )" [disabled]="dataFetchedFromSsn" required type="text" id="zipCode" placeholder="Postnummer*" [(ngModel)]="registerData.address.zipCode"
                  name="zipCode" minlength="5" maxlength="5" #zipCodeControl="ngModel" (input)="onInputChangeZipCode($event)" />

                  @if (showInputErrorMessages) {
                    @if (zipCodeControl.errors?.required) {
                      <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field"
                        >
                        <i class="error-msg-icon"></i>
                        <img alt="" src="../../assets/icons/error.svg" />
                        {{ errorMessages.zipCode.required }}
                      </p>
                    }
                    @if (!zipCodeControl.errors?.required && registerData.address.zipCode?.length !== 5) {
                      <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field"
                        >
                        <i class="error-msg-icon "></i>
                        <img alt="" src="../../assets/icons/error.svg" />
                        {{ errorMessages.zipCode.length }}
                      </p>
                    }
                  }
                </div>
                @if (registerData.address.zipCode?.length === 5 && zipIsAllZeros) {
                  <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field"
                    >
                    <i class="error-msg-icon "></i>
                    <img alt="" src="../../assets/icons/error.svg" />
                    {{ errorMessages.zipCode.allZeros }}
                  </p>
                }

                <div class="input-field-wrapper form-group has-error">
                  <input class="input-field field-without-icon w-100 fs-6 font-sans-serif"
                    [class.input-field-error]="showInputErrorMessages && (cityControl.errors?.required)" [disabled]="dataFetchedFromSsn" required type="text"
                    id="city" placeholder="Stad*" [(ngModel)]="registerData.address.city" name="city" #cityControl="ngModel" />

                    @if (showInputErrorMessages) {
                      @if (cityControl.errors?.required) {
                        <p class="text-danger help-block font-sans-serif f-for-input-fields-6 error-msg-for-input-field"
                          >
                          <i class="error-msg-icon"></i>
                          <img alt="" src="../../assets/icons/error.svg" />
                          {{ errorMessages.city.required }}
                        </p>
                      }
                    }
                  </div>

                  <!-- gender -->
                  <h2 class="text-header text-start">
                    Kön
                  </h2>
                  <div class="section-last-input-field-wrapper form-group has-error">
                    <div class="d-flex justify-content-center">
                      <div class="w-100">
                        <div class="position-relative d-inline-block w-100">
                          <select class="input-field field-without-icon w-100 fs-6 font-sans-serif pt-0 pb-0 w-100 custom-select"
                            [class.input-field-error]="showInputErrorMessages && (registerData.gender === Gender.EjValt)" [disabled]="dataFetchedFromSsn" required
                            name="gender" id="gender" [(ngModel)]="registerData.gender" (ngModelChange)="onGenderChange($event)"
                            #genderControl="ngModel"
                            [ngStyle]="{'color': !registerData.gender || registerData.gender.valueOf() === 0 ? '#00000077' : 'inherit'}">
                            @for (key of (genderDisplay | keyvalue); track key) {
                              <option [ngStyle]="{'color': key.key === 'EjValt' ? '#00000077' : 'inherit'}"
                                [value]="key.key">
                                {{ key.value === "EjValt" ? "Kön*" : key.value }}
                              </option>
                            }
                          </select>
                          <i class="fa-solid fa-chevron-down position-absolute top-50 fs-6 custom-select-arrow"></i>
                        </div>
                      </div>
                    </div>

                    @if (showInputErrorMessages) {
                      @if (registerData.gender === Gender.EjValt) {
                        <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field"
                          >
                          <i class="error-msg-icon"></i>
                          <img alt="" src="../../assets/icons/error.svg" />
                          {{ errorMessages.gender.defaultOption }}
                        </p>
                      }
                    }
                  </div>
                </section>

                <!-- email -->



                <h2 class="text-header text-start">
                  Mejladress
                </h2>
                <div class="input-field-wrapper">
                  <div class="input-wrapper custom-input-group align-items-center d-flex position-relative">
                    <img src="../../assets/icons/mail.svg" alt="" class="input-icon-left" />
        <input class="input-field w-100 fs-6 font-sans-serif" [class.input-field-error]="showInputErrorMessages && (
            emailControl.errors?.pattern ||
            emailControl.errors?.required
          ) || emailAlreadyExists" required type="email" id="email1" name="email" placeholder="namn@gmail.com"
                      #emailControl="ngModel" pattern="^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" autocomplete="username"
                      aria-describedby="emailHelp" [(ngModel)]="registerData.email" (input)="onInputChangeEmail($event)" />
                    </div>

                    @if (emailAlreadyExists) {
                      <p class="text-danger help-block font-sans-serif fs-6 error-msg">
                        <i class="error-msg-icon"></i>
                        <img alt="" src="../../assets/icons/error.svg" />
                        {{ errorMessages.email.emailInUse }}
                      </p>
                    }

                    @if (showEmailFormatError) {
                      @if (emailControl.errors?.pattern) {
                        <p class="text-danger help-block font-sans-serif fs-6 error-msg">
                          <i class="error-msg-icon"></i>
                          <img alt="" src="../../assets/icons/error.svg" />
                          {{ errorMessages.email.wrongFormat }}
                        </p>
                      }


                      @if (emailControl.errors?.required) {
                        <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field"
                          >
                          <i class="error-msg-icon"></i>
                          <img alt="" src="../../assets/icons/error.svg" />
                          {{ errorMessages.email.required }}
                        </p>
                      }
                    }
                  </div>

                  <!-- tel -->



                  <h2 class="text-header text-start">
                    Telefonnummer
                  </h2>
                  <div class="input-field-wrapper">
                    <div class="input-wrapper custom-input-group align-items-center d-flex position-relative">
                      <img src="../../assets/icons/phone.svg" alt="" class="input-icon-left" />

        <input class="input-field w-100 fs-6 font-sans-serif" [class.input-field-error]="showInputErrorMessages && (
            phoneNumberControl.errors?.required || (registerData.phoneNumber && registerData.phoneNumber.length !== 10)
          )" required type="text" placeholder="Telefonnummer*" id="phoneNumber" name="phoneNumber" [disabled]="phoneFetchedFromSsn"
                        #phoneNumberControl="ngModel" aria-describedby="emailHelp" [ngModel]="registerData.phoneNumber" minLength="10"
                        maxlength="10" (input)="onInputChangeNummericOnly($event)" />
                      </div>

                      @if (showInputErrorMessages) {
                        @if (phoneNumberControl.errors?.required) {
                          <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field"
                            >
                            <i class="error-msg-icon"></i>
                            <img alt="" src="../../assets/icons/error.svg" />
                            {{ errorMessages.phone.required }}
                          </p>
                        }
                      }
                      @if (phoneHasLengthError) {
                        <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field">
                          <i class="error-msg-icon"></i>
                          <img alt="" src="../../assets/icons/error.svg" />
                          {{ errorMessages.phone.length }}
                        </p>
                      }
                      @if (registerData.phoneNumber?.length === 10 && phoneIsAllZeros) {
                        <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field">
                          <i class="error-msg-icon"></i>
                          <img alt="" src="../../assets/icons/error.svg" />
                          {{ errorMessages.phone.allZeros }}
                        </p>
                      }
                    </div>

                    <!-- pwd 1 -->

                    <h2 class="text-header text-start">
                      Lösenord
                    </h2>

                    <div class="input-field-wrapper">
                      <div class="input-wrapper custom-input-group align-items-center d-flex position-relative">
                        <img src="../../assets/icons/lock.svg" alt="" class="input-icon-left" />
        <input class="input-field w-100 fs-6 font-sans-serif" [class.input-field-error]="showInputErrorMessages && (
            passwordControl1.errors?.required ||
            (registerData.password && registerData.password.length > 0 && (
              !passwordValidation.hasUppercase ||
              !passwordValidation.hasLowercase ||
              !passwordValidation.hasNumber ||
              !passwordValidation.hasSpecialChar ||
              !passwordValidation.hasMinLength
            ))
          )" required [type]="showPassword ? 'text' : 'password'" autocomplete="current-password" id="password1"
                          placeholder="Lösenord*" autocomplete="new-password" [(ngModel)]="registerData.password" name="password1"
                          #passwordControl1="ngModel" (input)="onPasswordChange()" />
                          <i class="fas toggle-password-icon position-absolute fs-6" [class.fa-eye]="!showPassword"
                            [class.fa-eye-slash]="showPassword" role="button" tabindex="0"
                            [attr.aria-label]="showPassword ? 'Dölj lösenord' : 'Visa lösenord'" (click)="togglePasswordVisibility()"
                          (keydown.enter)="togglePasswordVisibility()" (keydown.space)="togglePasswordVisibility()"></i>
                        </div>

                        <!-- Password validation indicators -->
                        @if (registerData.password && registerData.password.length > 0) {
                          <div class="password-requirements ms-3 me-3">
                            <div class="row mt-4">
                              <div class="col-xl-6">
                                <div class="requirement-item d-flex align-items-center mb-1">
                                  <i class="fas me-2 fs-4 fa-fw" [class.fa-times]="!passwordValidation.hasUppercase"
                                    [class.fa-check]="passwordValidation.hasUppercase"
                                  [style.color]="passwordValidation.hasUppercase ? '#28a745' : '#A13854'"></i>
                                  <span class="fs-6 font-sans-serif">
                                    {{ errorMessages.pwd.upperCase }}
                                  </span>
                                </div>
                              </div>

                              <div class="col-xl-6">
                                <div class="requirement-item d-flex align-items-center mb-1">
                                  <i class="fas me-2 fs-4 fa-fw" [class.fa-times]="!passwordValidation.hasLowercase"
                                    [class.fa-check]="passwordValidation.hasLowercase"
                                  [style.color]="passwordValidation.hasLowercase ? '#28a745' : '#A13854'"></i>
                                  <span class="fs-6 font-sans-serif">
                                    {{ errorMessages.pwd.lowerCase }}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="row mt-xl-4">
                              <div class="col-xl-6">
                                <div class="requirement-item d-flex align-items-center mb-1">
                                  <i class="fas me-2 fs-4 fa-fw" [class.fa-times]="!passwordValidation.hasNumber"
                                    [class.fa-check]="passwordValidation.hasNumber"
                                  [style.color]="passwordValidation.hasNumber ? '#28a745' : '#A13854'"></i>
                                  <span class="fs-6 font-sans-serif">
                                    {{ errorMessages.pwd.number }}
                                  </span>
                                </div>
                              </div>

                              <div class="col-xl-6">
                                <div class="requirement-item d-flex align-items-center mb-1">
                                  <i class="fas me-2 fs-4 fa-fw" [class.fa-times]="!passwordValidation.hasSpecialChar"
                                    [class.fa-check]="passwordValidation.hasSpecialChar"
                                  [style.color]="passwordValidation.hasSpecialChar ? '#28a745' : '#A13854'"></i>
                                  <span class="fs-6 font-sans-serif">
                                    {{ errorMessages.pwd.specialChar }}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="row mt-xl-4">
                              <div class="col-xl-6">
                                <div class="requirement-item d-flex align-items-center mb-1">
                                  <i class="fas me-2 fs-4 fa-fw" [class.fa-times]="!passwordValidation.hasMinLength"
                                    [class.fa-check]="passwordValidation.hasMinLength"
                                  [style.color]="passwordValidation.hasMinLength ? '#28a745' : '#A13854'"></i>
                                  <span class="fs-6 font-sans-serif">
                                    {{ errorMessages.pwd.minLength }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        }

                        @if (showInputErrorMessages) {
                          @if (passwordControl1.errors?.required) {
                            <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field"
                              >
                              <i class="error-msg-icon"></i>
                              <img alt="" src="../../assets/icons/error.svg" />
                              {{ errorMessages.pwd.required }}
                            </p>
                          }
                        }
                      </div>

                      <!-- pwd 2 -->


                      <div class="input-field-wrapper">
                        <div class="input-wrapper custom-input-group align-items-center d-flex position-relative">
                          <img src="../../assets/icons/lock.svg" alt="" class="input-icon-left" />
        <input class="input-field w-100 fs-6 font-sans-serif" [class.input-field-error]="showInputErrorMessages && (
            passwordControl2.errors?.required || showPwdNotTheSameMessage
          )" required type="password" id="passwordRepeated" placeholder="Repetera lösenord*"
                            autocomplete="new-password" [(ngModel)]="passwordRepeated" name="passwordRepeated" #passwordControl2="ngModel"
                            (ngModelChange)="comparePwds($event)" />
                          </div>

                          @if (showInputErrorMessages) {
                           @if (passwordControl2.errors?.required) {
                              <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field">
                                <i class="error-msg-icon fas"></i>
                                <img alt="" src="../../assets/icons/error.svg" />
                                {{ errorMessages.pwd.required }}
                              </p>
                            }
                          }
                          @if (showPwdNotTheSameMessage) {
                            <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-input-field">
                              <i class="error-msg-icon fas"></i>
                              <img alt="" src="../../assets/icons/error.svg" />
                              {{ errorMessages.pwd.notMatching }}
                            </p>
                          }
                        </div>


                        <div class="failed-register-error-wrapper d-flex align-items-center justify-content-center">
                          @if (registerError.hasErrored) {
                            <p class="text-danger help-block font-sans-serif fs-6 error-msg-for-failed-register"
                              >
                              <i class="error-msg-icon "></i>
                              <img alt="" src="../../assets/icons/error.svg" />
                              {{ registerError.message }}
                            </p>
                          }
                        </div>

                        <!-- checkboxes -->
                        <div class="form-group d-flex flex-column flex-xl-row flex-wrap gap-3 justify-content-xl-around ms-4 ms-xl-0">
                          <!-- checkbox 1 -->
                          <div class="form-group form-check p-0">
                            <input class="form-check-input fs-4" #AgreeMarketing name="agreeMarketing" type="checkbox" id="agreeMarketing"
                              (change)="onAgreeMarketingChanged(AgreeMarketing.checked)" [checked]="registerData.agreeMarketing" />

                              <label class="font-sans-serif fs-6" for="agreeMarketing">Acceptera användaravtal</label>
                            </div>

                            <!-- checkbox 2 -->
                            <div class="form-group form-check p-0">
                              <input class="form-check-input fs-4" #SubscribeToEmailNotification name="SubscribeToEmailNotification"
                                type="checkbox" id="SubscribeToEmailNotification"
                                (change)="onSubscribeToEmailChanged(SubscribeToEmailNotification.checked)"
                                [checked]="registerData.subscribeToEmailNotification" />

                                <label class="font-sans-serif fs-6" for="SubscribeToEmailNotification">Vill du få nyhetsbrev?</label>
                              </div>
                            </div>


                            <!-- subm btn -->
    <button class="btn mt-4 w-100 text-white fs-4 fw-bold form-submit-btn font-sans-serif" type="submit" (click)="
        userForm.invalid || !AgreeMarketing.checked || !isPasswordValid() || !doPasswordsMatch() || zipIsAllZeros || phoneIsAllZeros
          ? setShowErrorMessages()
          : registerNewUser()
      ">
                              Fortsätt
                            </button>

                            <!-- error msg if marketing not checked -->
                            @if (showMarketingErrorMessage || showInputErrorMessages) {
                              <div class="d-flex justify-content-center align-items-center m-0 p-0">
                                @if (!AgreeMarketing.checked) {
                                  <p class="agreement-not-checked-wrapper mt-3 text-danger help-block font-sans-serif fs-6 error-msg d-flex align-items-center  justify-content-center flex-column"
                                    >
                                    <span class="d-flex justify-content-center align-items-center gap-1">
                                      <i class="error-msg-icon "></i>
                                      <img alt="" src="../../assets/icons/error.svg" />
                                      <span class="error-msg-for-agreement-not-checked">
                                        Du måste acceptera användaravlet
                                      </span>
                                    </span>
                                    <span class="error-msg-for-agreement-not-checked">för att fortsätta</span>
                                  </p>
                                }
                              </div>
                            }
                          </form>
                        </div>